<div class="row position-relative">
  <div class="col position-relative resume-on-newtab">
    <iframe [src]="previewresumeurl" frameborder="0" type="application/pdf" allowfullscreen
      class="doc-iframe-div"></iframe>
  </div>
</div>  